import { render } from "./TextareaField.vue?vue&type=template&id=7a31fac6&scoped=true"
import script from "./TextareaField.vue?vue&type=script&lang=js"
export * from "./TextareaField.vue?vue&type=script&lang=js"

import "./TextareaField.vue?vue&type=style&index=0&id=7a31fac6&scoped=true&lang=scss"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a31fac6"]])

export default __exports__